import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../api';

function clp(n) {
  return `$${Number(n || 0).toLocaleString('es-CL')}`;
}

export default function UnidadFichaPanel({ row, onClose, canEdit }) {
  const { cid } = useParams();
  const [cuenta, setCuenta] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!row?.id) return;
    api
      .get(`/gastos-comunes/condominios/${cid}/portal/unidades/${row.id}/cuenta`)
      .then((r) => setCuenta(r.data))
      .catch((e) => setError(e.response?.data?.error || e.message));
  }, [cid, row?.id]);

  if (!row) return null;

  const t = row.titulares?.[0];

  return (
    <aside className="ficha-panel">
      <div className="ficha-panel-head">
        <div>
          <strong>Propiedad {row.codigoDepto}</strong>
          <div className="ficha-sub">{row.titularNombre || '—'}</div>
        </div>
        <button type="button" className="btn-ghost ficha-close" onClick={onClose}>
          ×
        </button>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      <div className="ficha-kpis">
        <div>
          <span>Total a pagar</span>
          <strong>{clp(row.totalPagar)}</strong>
        </div>
        <div>
          <span>Deuda vencida</span>
          <strong>{clp(row.deudaVencida)}</strong>
        </div>
      </div>
      {t && (
        <p className="ficha-meta">
          {t.email || 'Sin correo'} · Cuota ref. {row.cuotaMensual != null ? clp(row.cuotaMensual) : '—'}
        </p>
      )}
      {canEdit && (
        <div className="ficha-actions">
          <Link to={`/c/${cid}/cobranza`} className="btn secondary">
            Ir a Ingresos
          </Link>
        </div>
      )}
      {cuenta && (
        <>
          <h4 className="ficha-section-title">Últimos pagos</h4>
          <ul className="ficha-list">
            {(cuenta.pagos || []).slice(0, 8).map((p) => (
              <li key={p.id}>
                Folio {p.folioNum} · {clp(p.importe)} ·{' '}
                {p.fechaPago ? new Date(p.fechaPago).toLocaleDateString('es-CL') : '—'}
              </li>
            ))}
          </ul>
        </>
      )}
    </aside>
  );
}
